import { render, staticRenderFns } from "./PendingPayment.vue?vue&type=template&id=b857d6a6"
import script from "./PendingPayment.vue?vue&type=script&lang=js"
export * from "./PendingPayment.vue?vue&type=script&lang=js"
import style0 from "./PendingPayment.vue?vue&type=style&index=0&id=b857d6a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports